<template>
  <div class="body-div">
    <div class="stat-buttons">
      <form>
        <input type="number" id="profit" />
        <button type="button" v-on:click="getStatsByProfit()">
          Get stats by profit
        </button>
      </form>
      <button v-on:click="getStatsByProfit(0)">Get regular stats</button>
    </div>
    <div class="top-div">
      <div class="table">
        <table :key="time" v-for="time in Object.keys(niPerformanceBusy)">
          <thead>
            <tr class="text-center">
              <span v-if="time === '0'">
                TODAY
              </span>
              <span v-if="time !== '0'">
                LAST
                {{ time }}
                DAYS
              </span>
            </tr>
          </thead>

          <tbody>
            <table
              v-for="niState in NiPerformance.niPerformance[time].slice(0, 3)"
              :key="niState.id"
            >
              <tr>
                <td>
                  {{
                    dictionaries.activity.not_int_states.find(
                      item => item.id === niState.id
                    ).name
                  }}
                </td>
                <td>
                  {{
                    niState.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ | {{ niState.total }} | {{ niState.conversion_stat }} |
                  {{
                    niState.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
              </tr>
              <tr>
                campaigns:
              </tr>
              <tr
                v-for="stat in niState['campaign_aaid'].slice(0, 3)"
                :key="stat.id"
              >
                <td>{{ stat.id }}</td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ | {{ stat.total }} | {{ stat.conversion_stat }} |
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
              </tr>
              <tr>
                <hr />
                keywords:
              </tr>
              <tr v-for="stat in niState['keyword'].slice(0, 3)" :key="stat.id">
                <td>{{ stat.id }}</td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ | {{ stat.total }} | {{ stat.conversion_stat }} |
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
              </tr>
              <tr>
                <hr />
                users:
              </tr>
              <tr v-for="stat in niState['users'].slice(0, 3)" :key="stat.id">
                <td>
                  {{
                    salesPersonList.find(item => item.id === stat.id).full_name
                  }}
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ | {{ stat.total }} | {{ stat.conversion_stat }} |
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
              </tr>
              <tr>
                <hr />
                countries:
              </tr>
              <tr
                v-for="stat in niState['country_id'].slice(0, 3)"
                :key="stat.id"
              >
                <td>
                  {{
                    dictionaries.general.countries.find(
                      country => country.id === stat.id
                    ).name
                  }}
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ | {{ stat.total }} | {{ stat.conversion_stat }} |
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
              </tr>
              <hr />
            </table>
          </tbody>

          <tbody>
            <table
              v-for="niState in NiPerformance.userPerformance[time].slice(0, 3)"
              :key="niState.id"
            >
              <tr>
                <td>
                  {{
                    salesPersonList.find(item => item.id === niState.id)
                      .full_name
                  }}
                </td>
                <td>
                  {{
                    niState.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ | {{ niState.total }} | {{ niState.conversion_stat }} |
                  {{
                    niState.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
              </tr>
              <tr>
                campaigns:
              </tr>
              <tr
                v-for="stat in niState['campaign_aaid'].slice(0, 3)"
                :key="stat.id"
              >
                <td>{{ stat.id }}</td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ | {{ stat.total }} | {{ stat.conversion_stat }} |
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.not_interested_state_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.activity.not_int_states.find(
                        item => item.id === cond.id
                      ).name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
              </tr>
              <tr>
                <hr />
                keywords:
              </tr>
              <tr v-for="stat in niState['keyword'].slice(0, 3)" :key="stat.id">
                <td>{{ stat.id }}</td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ | {{ stat.total }} | {{ stat.conversion_stat }} |
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.not_interested_state_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.activity.not_int_states.find(
                        item => item.id === cond.id
                      ).name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
              </tr>
              <tr>
                <hr />
                not interested states:
              </tr>
              <tr
                v-for="stat in niState['not_interested_state_id'].slice(0, 3)"
                :key="stat.id"
              >
                <td>
                  {{
                    dictionaries.activity.not_int_states.find(
                      item => item.id === stat.id
                    ).name
                  }}
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ | {{ stat.total }} | {{ stat.conversion_stat }} |
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
              </tr>
              <tr>
                <hr />
                countries:
              </tr>
              <tr
                v-for="stat in niState['country_id'].slice(0, 3)"
                :key="stat.id"
              >
                <td>
                  {{
                    dictionaries.general.countries.find(
                      country => country.id === stat.id
                    ).name
                  }}
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ | {{ stat.total }} | {{ stat.conversion_stat }} |
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.not_interested_state_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.activity.not_int_states.find(
                        item => item.id === cond.id
                      ).name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
              </tr>
              <hr />
            </table>
          </tbody>

          <tbody>
            <table
              v-for="niState in NiPerformance.keyPerformance[time].slice(0, 3)"
              :key="niState.id"
            >
              <tr>
                <td>
                  {{ niState.id }}
                </td>
                <td>
                  {{
                    niState.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ | {{ niState.total }} | {{ niState.conversion_stat }} |
                  {{
                    niState.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
              </tr>
              <tr>
                campaigns:
              </tr>
              <tr
                v-for="stat in niState['campaign_aaid'].slice(0, 3)"
                :key="stat.id"
              >
                <td>{{ stat.id }}</td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ | {{ stat.total }} | {{ stat.conversion_stat }} |
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.not_interested_state_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span
                    >{{
                      dictionaries.activity.not_int_states.find(
                        item => item.id === cond.id
                      ).name
                    }}
                    <label> </label
                  ></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
              </tr>
              <tr>
                <hr />
                not interested states:
              </tr>
              <tr
                v-for="stat in niState['not_interested_state_id'].slice(0, 3)"
                :key="stat.id"
              >
                <td>
                  {{
                    dictionaries.activity.not_int_states.find(
                      item => item.id === stat.id
                    ).name
                  }}
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ | {{ stat.total }} | {{ stat.conversion_stat }} |
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
              </tr>
              <tr>
                <hr />
                users:
              </tr>
              <tr v-for="stat in niState['users'].slice(0, 3)" :key="stat.id">
                <td>
                  {{
                    salesPersonList.find(item => item.id === stat.id).full_name
                  }}
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ | {{ stat.total }} | {{ stat.conversion_stat }} |
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.not_interested_state_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span
                    >{{
                      dictionaries.activity.not_int_states.find(
                        item => item.id === cond.id
                      ).name
                    }}
                    <label> </label
                  ></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
              </tr>
              <tr>
                <hr />
                countries:
              </tr>
              <tr
                v-for="stat in niState['country_id'].slice(0, 3)"
                :key="stat.id"
              >
                <td>
                  {{
                    dictionaries.general.countries.find(
                      country => country.id === stat.id
                    ).name
                  }}
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ | {{ stat.total }} | {{ stat.conversion_stat }} |
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.not_interested_state_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span
                    >{{
                      dictionaries.activity.not_int_states.find(
                        item => item.id === cond.id
                      ).name
                    }}
                    <label> </label
                  ></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
              </tr>
              <hr />
            </table>
          </tbody>

          <tbody>
            <table
              v-for="niState in NiPerformance.countryPerformance[time].slice(
                0,
                3
              )"
              :key="niState.id"
            >
              <tr>
                <td>
                  {{
                    dictionaries.general.countries.find(
                      country => country.id === niState.id
                    ).name
                  }}
                </td>
                <td>
                  {{
                    niState.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ | {{ niState.total }} | {{ niState.conversion_stat }} |
                  {{
                    niState.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
              </tr>
              <tr>
                campaigns:
              </tr>
              <tr
                v-for="stat in niState['campaign_aaid'].slice(0, 3)"
                :key="stat.id"
              >
                <td>{{ stat.id }}</td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ | {{ stat.total }} | {{ stat.conversion_stat }} |
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.not_interested_state_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.activity.not_int_states.find(
                        item => item.id === cond.id
                      ).name
                    }}
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
              </tr>
              <tr>
                <hr />
                keywords:
              </tr>
              <tr v-for="stat in niState['keyword'].slice(0, 3)" :key="stat.id">
                <td>{{ stat.id }}</td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ | {{ stat.total }} | {{ stat.conversion_stat }} |
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.not_interested_state_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.activity.not_int_states.find(
                        item => item.id === cond.id
                      ).name
                    }}
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
              </tr>
              <tr>
                <hr />
                users:
              </tr>
              <tr v-for="stat in niState['users'].slice(0, 3)" :key="stat.id">
                <td>
                  {{
                    salesPersonList.find(item => item.id === stat.id).full_name
                  }}
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ | {{ stat.total }} | {{ stat.conversion_stat }} |
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.not_interested_state_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.activity.not_int_states.find(
                        item => item.id === cond.id
                      ).name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
              </tr>
              <tr>
                <hr />
                not interested states:
              </tr>
              <tr
                v-for="stat in niState['not_interested_state_id'].slice(0, 3)"
                :key="stat.id"
              >
                <td>
                  {{
                    dictionaries.activity.not_int_states.find(
                      item => item.id === stat.id
                    ).name
                  }}
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ | {{ stat.total }} | {{ stat.conversion_stat }} |
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
              </tr>
              <hr />
            </table>
          </tbody>

          <tbody>
            <table
              v-for="niState in NiPerformance.campPerformance[time].slice(0, 3)"
              :key="niState.id"
            >
              <tr>
                <td>
                  {{ niState.id }}
                </td>
                <td>
                  {{
                    niState.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ | {{ niState.total }} | {{ niState.conversion_stat }} |
                  {{
                    niState.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
              </tr>
              <tr>
                not interested states:
              </tr>
              <tr
                v-for="stat in niState['not_interested_state_id'].slice(0, 3)"
                :key="stat.id"
              >
                <td>
                  {{
                    dictionaries.activity.not_int_states.find(
                      item => item.id === stat.id
                    ).name
                  }}
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ | {{ stat.total }} | {{ stat.conversion_stat }} |
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
              </tr>
              <tr>
                <hr />
                keywords:
              </tr>
              <tr v-for="stat in niState['keyword'].slice(0, 3)" :key="stat.id">
                <td>{{ stat.id }}</td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ | {{ stat.total }} | {{ stat.conversion_stat }} |
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.not_interested_state_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span
                    >{{
                      dictionaries.activity.not_int_states.find(
                        item => item.id === cond.id
                      ).name
                    }}
                    <label> </label
                  ></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
              </tr>
              <tr>
                <hr />
                users:
              </tr>
              <tr v-for="stat in niState['users'].slice(0, 3)" :key="stat.id">
                <td>
                  {{
                    salesPersonList.find(item => item.id === stat.id).full_name
                  }}
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ | {{ stat.total }} | {{ stat.conversion_stat }} |
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.not_interested_state_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span
                    >{{
                      dictionaries.activity.not_int_states.find(
                        item => item.id === cond.id
                      ).name
                    }}
                    <label> </label
                  ></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
              </tr>
              <tr>
                <hr />
                countries:
              </tr>
              <tr
                v-for="stat in niState['country_id'].slice(0, 3)"
                :key="stat.id"
              >
                <td>
                  {{
                    dictionaries.general.countries.find(
                      country => country.id === stat.id
                    ).name
                  }}
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ | {{ stat.total }} | {{ stat.conversion_stat }} |
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.not_interested_state_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span
                    >{{
                      dictionaries.activity.not_int_states.find(
                        item => item.id === cond.id
                      ).name
                    }}
                    <label> </label
                  ></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪ | {{ cond.total }} | {{ cond.conversion_stat }} |
                    {{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                </td>
              </tr>
              <hr />
            </table>
          </tbody>
        </table>
      </div>

      <div class="flat-bottom-div">
        <div class="paginationContainer text-center">
          <div class="btn-group ">
            <button
              v-if="pageNum !== 1"
              @click="backPage"
              class="btn btn-sm s-btn-sm page-btn"
              :disabled="pageNum === 1"
            >
              <i class="fa fa-chevron-left"></i>
            </button>
            <span class="btn btn-sm s-btn-sm page-num ">
              {{ pageNum }}
            </span>
            <button @click="nextPage" class="btn btn-sm s-btn-sm page-btn">
              <i class="fa fa-chevron-right"></i>
            </button>
          </div>
        </div>
        <div class="fab"><span class="fas fa-file-csv"></span></div>
      </div>

      <loader
        class="loader"
        :size="'8px'"
        v-if="
          niPerformanceBusy[0] || niPerformanceBusy[30] || niPerformanceBusy[90]
        "
      ></loader>
    </div>
  </div>
</template>

<script>
import Loader from "../../../../../main/misc.main/loader/Loader";
import {mapGetters, mapState} from "vuex";
import apiClientCreator from "../../../../../helpers/api/request";
export default {
  name: "NotInterested.container",
  components: { Loader },
  data() {
    return {
      // reqNIPerformanceReportsBusyLast30: false,
      //
      // NIPerformanceLast30: {
      //   highest_campaign:[],
      //   highest_countries:[],
      //   highest_campaign_users:[],
      //   highest_countries_users:[],
      //   highest_keyword:[],
      //   highest_keyword_users:[],
      //   highest_ni:[],
      // },
      niPerformanceBusy: {
        0: false,
        30: false,
        90: false
      },
      NiPerformance: {
        keyPerformance: {
          0: [],
          30: [],
          90: []
        },
        userPerformance: {
          0: [],
          30: [],
          90: []
        },
        countryPerformance: {
          0: [],
          30: [],
          90: []
        },
        campPerformance: {
          0: [],
          30: [],
          90: []
        },
        niPerformance: {
          0: [],
          30: [],
          90: []
        }
      },
      pageNum: 1
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", ["dictionaries", "salesPersonList"])
  },
  created() {},
  methods: {
    paginate(arr, page_number, page_size) {
      return arr.slice((page_number - 1) * page_size, page_number * page_size);
    },
    nextPage() {
      this.pageNum = this.pageNum + 1;
    },
    backPage() {
      if (this.pageNum > 1) {
        this.pageNum = this.pageNum - 1;
      }
    },
    getPerformanceNIByTimeFrame(time_frame, profit, order_by) {
      this.clearData(time_frame);
      if (
        !this.niPerformanceBusy[time_frame] &&
        this.checkPermissions(this.auth, [1, 2, 3, 4, 12])
      ) {
        this.niPerformanceBusy[time_frame] = true;
        apiClientCreator(
          `reports/group/ni/time_frame/${time_frame}/${profit}/${order_by}`
        )
          .get("")
          .then(res => {
            this.NiPerformance.keyPerformance[time_frame] = res.data["keyword"];
            this.NiPerformance.userPerformance[time_frame] = res.data["users"];
            this.NiPerformance.countryPerformance[time_frame] =
              res.data["country_id"];
            this.NiPerformance.campPerformance[time_frame] =
              res.data["campaign_aaid"];
            this.NiPerformance.niPerformance[time_frame] =
              res.data["not_interested_state_id"];

            this.niPerformanceBusy[time_frame] = false;
          })
          .catch(err => {
            this.niPerformanceBusy[time_frame] = false;
          });
      }
    },
    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    },
    getStatsByProfit(profit = false) {
      if (profit === false) {
        profit = document.getElementById("profit").value;
      }

      this.getPerformanceNIByTimeFrame(0, profit, "profit");
      this.getPerformanceNIByTimeFrame(30, profit, "profit");
      this.getPerformanceNIByTimeFrame(90, profit, "profit");
    },
    clearData(time_frame) {
      this.NiPerformance.niPerformance[time_frame] = [];
      this.NiPerformance.campPerformance[time_frame] = [];
      this.NiPerformance.countryPerformance[time_frame] = [];
      this.NiPerformance.keyPerformance[time_frame] = [];
      this.NiPerformance.userPerformance[time_frame] = [];
    }
  }
};
</script>

<style scoped>
.body-div {
  padding: 4px 5px 1px 5px;
}
.top-div {
  width: 100%;
  height: max-content;
  margin: auto;
  background: white;
  border-radius: 3px;
  min-height: 300px;
  padding: 5px;
}
.bottom-div {
  width: 100%;
  height: 650px;
  overflow-y: scroll;
  margin: 5px auto;
  background: white;
  border-radius: 3px;
  padding: 5px;
  position: relative;
}
.fab {
  background-color: transparent;
  padding: 0;
  font-size: 30px;
  line-height: 30px;
  color: green;
  text-align: center;
  position: absolute;
  right: 10px;
  bottom: 10px;
  border-radius: 20%;
  transition: all 0.1s ease-in-out;
  cursor: pointer;
}

.fab:hover {
  box-shadow: 0 5px 11px 0 #666;
  transform: scale(1.05);
}
.table {
  /* float: left;*/
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 10px;
}
.table table {
  font-size: 12px;
  width: 1500px;
  /*   margin-right: auto;*/
  margin: 3em 7px;
}
/*.ca-auto-status-override{
      width: 355px !important;
    }
    .ca-regular-status-override{
      width: 450px !important;
    }*/
.table thead {
  border-bottom: solid 2px #eff3f6;
}
.table th {
  text-align: left;
  font-size: 12px;
}
.table .td-count {
  text-align: center;
}
.table td {
  border-bottom: solid 2px #eff3f6;
}
.text-center {
  font-weight: bold;
}

.paginationContainer {
  /*margin-left: 10px;*/
  font-size: 15px;
  width: 110px;
  margin-left: auto;
  margin-right: auto;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
.page-btn {
  background: white;
}

.page-num {
  cursor: inherit;
}
.loader {
  position: absolute;
  bottom: 20px;

  left: 0;
  right: 0;
}
.flat-bottom-div {
  margin-top: 10px;
  height: 40px;
  width: 100%;
}
.tr-main-cat {
  background: #44a2d2;
  color: white;
  padding: 1px;
  width: 100%;
}
.stat-buttons {
  display: flex;
  justify-content: space-evenly;
  padding: 2em 0;
}
</style>
